import { render, staticRenderFns } from "./SfAlert.vue?vue&type=template&id=3dc849d0&"
import script from "./SfAlert.vue?vue&type=script&lang=js&"
export * from "./SfAlert.vue?vue&type=script&lang=js&"
import style0 from "./SfAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports